import { render, staticRenderFns } from "./ModalDeleteUser.vue?vue&type=template&id=470b71c0&scoped=true&"
import script from "./ModalDeleteUser.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b71c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470b71c0')) {
      api.createRecord('470b71c0', component.options)
    } else {
      api.reload('470b71c0', component.options)
    }
    module.hot.accept("./ModalDeleteUser.vue?vue&type=template&id=470b71c0&scoped=true&", function () {
      api.rerender('470b71c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/userprofile/ModalDeleteUser.vue"
export default component.exports